<header
  class="tw:print:hidden tw:fixed tw:top-0 tw:left-0 tw:right-0 tw:z-[1000] navbar"
  [class.is-mobile]="isBurgerMenuBpMatched$ | async"
  [class.navbar-default]="type === 'default'"
  [class.navbar-secondary]="type === 'secondary'"
>
  <nav class="navbar-collapse tw:flex tw:items-center tw:flex-1 tw:min-w-0 tw:relative collapse">
    @if ((isBurgerMenuBpMatched$ | async) === false) {
      <ng-content select="di-navbar-brand" />
    }
    <ng-content select="di-navbar-menu" />
    <ng-content select="di-navbar-right-menu" />
  </nav>
</header>
